export type RealtimeDispatchMode =
  | 'online-ack'
  | 'online-queued'
  | 'offline-queued';

export function resolveRealtimeDispatchMode(options: {
  isOnline: boolean;
  websocketConnected: boolean;
}): RealtimeDispatchMode {
  if (!options.isOnline) {
    return 'offline-queued';
  }

  return options.websocketConnected ? 'online-ack' : 'online-queued';
}
